import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=86dc85aa&"
import script from "./BaseToggle.vue?vue&type=script&lang=ts&"
export * from "./BaseToggle.vue?vue&type=script&lang=ts&"
import style0 from "./BaseToggle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports